import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { TokensSchema, WorkspacesResponseSchema } from '../shared/schemas.js';

export type { WorkspaceItem } from '../shared/schemas.js';

export const switchWorkspaces = defaultApi.declareEndpoint({
  url: 'authentication/v1/workspaces/',
  method: 'POST',
  requestSchema: z.object({
    company: z.number(),
  }),
  responseSchema: TokensSchema,
});

const workspacePinUrlParamsSchema = z.object({ companyId: z.number() });

// Pin answers 201 and unpin 204, both without a body.
export const pinWorkspace = defaultApi.declareEndpoint({
  url: 'authentication/v1/users/workspace-pin/$companyId/',
  method: 'POST',
  urlParamsSchema: workspacePinUrlParamsSchema,
  responseSchema: z.unknown(),
});

export const unpinWorkspace = defaultApi.declareEndpoint({
  url: 'authentication/v1/users/workspace-pin/$companyId/',
  method: 'DELETE',
  urlParamsSchema: workspacePinUrlParamsSchema,
  responseSchema: z.unknown(),
});

export const workspaces = defaultClient.query({
  url: 'authentication/v1/workspaces/?is_activated=true&is_active=true' as const,
  method: 'GET',
  querySchema: z.object({
    workspace_id: z.number().optional(),
  }),
  responseSchema: WorkspacesResponseSchema,
  processResponse(data) {
    return data;
  },
});
